// @flow
import React, { type Node } from 'react';
import { QueryRenderer, type RenderProps } from 'react-relay';
import { Loader } from 'shared/legacy';
import ErrorPage from '../ErrorPage';
import { type RelayEnvironmentType } from 'core/withRelayEnvironment';

type Props = {
  environment: RelayEnvironmentType,
  variables?: any,
  query: any,
  render: (props: any) => Node,
  renderLoading?: () => Node | null,
  renderError?: (error: ?Error) => Node | null,
};

const QueryRendererContainer = ({
  render,
  renderLoading = () => <Loader />,
  renderError = () => <ErrorPage status="500" />,
  ...queryRenderProps
}: Props) => (
  <QueryRenderer
    dataFrom="STORE_THEN_NETWORK"
    {...queryRenderProps}
    render={({ error, props }: RenderProps) => {
      if (props) {
        return render(props);
      } else if (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return renderError(error);
      } else {
        return renderLoading();
      }
    }}
  />
);

export default QueryRendererContainer;
